import { Button, Dialog, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import ModalHeader from '../../../../components/ModalHeader';
import { useTheme } from '@emotion/react';
import moment from 'moment';
import { dialogButtonCancel } from '../../../../utils/commonStyle';
import ClearIcon from '@mui/icons-material/Clear';
import { useSelector } from 'react-redux';
import DocumentViewer from '../../../../components/DocumentViewer';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

const screeningStatus = {
  pending: '#f8f5e8',
  accepted: '#00A63226',
  rejected: '#C220201A',
  completed: '#006DFF1A',
  expired: '#f3f4f7',
  pendingColor: '#BA9B1D',
  acceptedColor: '#00A632',
  rejectedColor: '#C22020',
  completedColor: '#006DFF',
  expiredColor: '#14285A80',
};

export default function HistoryDetails({ modelOpen, onModelHandleClose, details, masterData }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { user } = useSelector((state) => state.auth);
  const {t} = useTranslation()

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        flex={1}
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="sticky top-[0] !bg-[#ffffff] z-[9] h-[56px]"
          style={{ paddingLeft: '24px', paddingRight: '24px' }}
        >
          <div className="flex">
            <Typography
              color="#14285A"
              className="fw-medium fs-14 ff-Roboto"
            >
              {t('History Details')}
            </Typography>
          </div>
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Stack
              direction="row"
              className="mr-4 rounded-[16px] h-[28px] my-2 "
              sx={{ backgroundColor: '#f3f4f7', color: theme.palette.primary.text }}
            >
              <Stack
                justifyContent={'center'}
                alignItems={'center'}
                className="fw-regular fs-12 ff-Roboto h-[28px] w-[78px] px-[10px]  capitalize"
              >
                <Typography
                  className="fw-medium ff-Roboto fs-12 capitalize"
                  color={text}
                >
                  {t(details?.stage)}
                </Typography>
              </Stack>

              {Boolean(details?.quoteStatus) && <Stack
                justifyContent={'center'}
                alignItems={'center'}
                className="fw-regular fs-12 ff-Roboto h-[28px] w-[78px] px-[10px] rounded-[16px] capitalize"
                sx={{ backgroundColor: details?.quoteStatus ? screeningStatus[details?.quoteStatus] : 'transparent', color: details?.quoteStatus ? screeningStatus[`${details?.quoteStatus}Color`] : theme.palette.primary.text }}
              >
                {t(details?.quoteStatus)}
              </Stack>}
            </Stack>
            <IconButton onClick={() => onModelHandleClose(false)}>
              <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
            </IconButton>
          </Stack>
        </Stack>
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Stack
          direction={'row'}
          className="px-[16px] !mb-[16px] mt-[26px]"
        >
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {t('ID')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {masterData?.id}
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular "
              color={text}
            >
              {t('Timestamp')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
            >
              {moment(details?.createdOn).format('DD-MMM-YYYY HH:mm')}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction={'row'}
          className="px-[16px] !mb-[16px]"
        >
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {user?.type !== 'trader' ? t('Trader') : t('Client')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {user?.type !== 'trader' ? masterData?.traderName : masterData?.companyName}
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular "
              color={text}
            >
              EUA
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
            >
              {masterData?.euaRequired} tCO2
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction={'row'}
          className="px-[16px] !mb-[16px]"
        >
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular !capitalize"
              color={text}
            >
              {t('Display name')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {masterData?.displayName}
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular "
              color={text}
            >
              {t('Price / EUA')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
            >
              {(details?.price && '€ ' + parseFloat(details?.price)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })) || '-'}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction={'row'}
          className="px-[16px] !mb-[16px]"
        >
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {t('Type')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {t(masterData?.priceType)}/{t(masterData?.tradeType)}
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular !capitalize"
              color={text}
            >
              {t('Total amount')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
            >
              {(masterData?.totalAmount && '€ ' + parseFloat(masterData?.totalAmount)?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })) || 'NA'}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          direction={'row'}
          className="px-[16px] !mb-[16px]"
        >
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {t('Quote valid till')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
              style={{ maxWidth: '225px' }}
            >
              {details?.validity ? moment(details?.validity).format('DD-MMM-YYYY HH:mm') : 'NA'}
            </Typography>
          </Stack>
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular !capitalize"
              color={text}
            >
              {t('Delivery date')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
            >
              {masterData?.deliveryDate ? moment(masterData?.deliveryDate).format('DD-MMM-YYYY') : 'NA'}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
          className="!my-[10px]"
        />
        <Stack
          className="p-[16px]"
          direction={'row'}
          alignItems={'center'}
        >
          {details?.attachment && (
            <Stack flex={0.5}>
              <DocumentViewer data={details} />
            </Stack>
          )}
          <Stack flex={0.5}>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={text}
            >
              {t('Remark')}
            </Typography>
            <Typography
              className="fs-14 ff-Roboto fw-medium capitalize"
              color={text}
              style={{ marginTop: '5px', maxWidth: '225px' }}
            >
              {details?.remarks || '-'}
            </Typography>
          </Stack>
        </Stack>
        <Stack flexGrow={1} />
        <Stack
          direction="row"
          justifyContent="flex-end"
          className="px-4 py-2 !justify-end p-[0px] sticky bottom-[0] !mt-[32px]"
          // className="!mt-[44px] h-[66px] "
          style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
        >
          <Button
            sx={[
              dialogButtonCancel,
              {
                color: theme.palette.primary.main,
                textTransform: "uppercase",
                '&:hover': {},
              },
            ]}
            style={{ width: '128px', height: '40px' }}
            onClick={() => {
              onModelHandleClose(false);
            }}
          >
            {t('Close')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
